var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
var APP_ORIGIN = "silk";
// The deploy build pins this to "off", which a .env line or a shell export
// cannot override; only start and serve:local/dev/prod set a real key. It is
// what makes a non-Silk host trust this app-origin.
var STB_DEV_KEY = process.env.REACT_APP_STB_DEV_KEY;
var STB_DEV_KEY_OFF = "off";
export var appHeaders = function () {
    var headers = { "app-origin": APP_ORIGIN };
    if (STB_DEV_KEY && STB_DEV_KEY !== STB_DEV_KEY_OFF) {
        headers["stb-dev-key"] = STB_DEV_KEY;
    }
    return headers;
};
var api = axios.create({
    baseURL: "/api/v1/",
});
api.interceptors.request.use(function (config) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        config.headers = __assign(__assign({}, config.headers), appHeaders());
        config.withCredentials = false;
        return [2 /*return*/, config];
    });
}); }, function (error) { return Promise.reject(error); });
api.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var response, message;
    return __generator(this, function (_a) {
        try {
            response = error.response;
            if (response && response.status === 401) {
                message = response.data.message;
                if (message !== "Required fields are missing") {
                    console.log("handle global state reset");
                }
            }
            if (!(error instanceof Error)) {
                return [2 /*return*/, Promise.reject(new Error(error.response.data.message || error.message))];
            }
            return [2 /*return*/, Promise.reject(error)];
        }
        catch (err) {
            return [2 /*return*/, Promise.reject(new Error(err.message))];
        }
        return [2 /*return*/];
    });
}); });
export var getRequest = function (url, params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get(url, { params: params })];
            case 1:
                response = _a.sent();
                if (response) {
                    return [2 /*return*/, response];
                }
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var postRequest = function (url, body) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.post(url, body)];
            case 1:
                response = _a.sent();
                if (response) {
                    return [2 /*return*/, response];
                }
                return [3 /*break*/, 3];
            case 2:
                error_2 = _a.sent();
                throw error_2;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var putRequest = function (url, body) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.put(url, body)];
            case 1:
                response = _a.sent();
                if (response) {
                    return [2 /*return*/, response];
                }
                return [3 /*break*/, 3];
            case 2:
                error_3 = _a.sent();
                console.log(error_3);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
// export const deleteRequest = async (url, params) => {
//     try {
//         return await api.delete(url, { params });
//     } catch (error) {
//         console.log(error)
//     }
// };
//
// export const patchRequest = async (url, body) => {
//     try {
//         return await api.patch(url, body);
//     } catch (error) {
//         console.log(error)
//     }
// };



//////////////////
// WEBPACK FOOTER
// ./src/services/api.ts
// module id = 23
// module chunks = 1